import type { MonthInsight } from '../../../../entities/summary/index.js';
import { List, ListItem } from '../../../../shared/ui/index.js';
import {
  forecastLineOf,
  grownTitleOf,
  isInsightEmpty,
  monthHeadlineOf,
  usualLineOf,
} from '../../lib/month-insight-text.js';
import styles from './current-month-insight.module.css';

type CurrentMonthInsightProps = {
  insight: MonthInsight;
  onOpenCategory: (categoryId: string) => void;
};

export const CurrentMonthInsight = ({ insight, onOpenCategory }: CurrentMonthInsightProps) => {
  if (isInsightEmpty(insight)) {
    return null;
  }

  const usualLine = usualLineOf(insight);
  const forecastLine = forecastLineOf(insight);

  return (
    <>
      <section className={styles.insight} aria-label="Підсумок місяця">
        <p className={styles.headline}>{monthHeadlineOf(insight)}</p>
        {usualLine !== null && <p className={styles.note}>{usualLine}</p>}
        {forecastLine !== null && <p className={styles.note}>{forecastLine}</p>}
      </section>

      {insight.grown.length > 0 && (
        <List header="Що виросло">
          {insight.grown.map((row) => (
            <ListItem
              key={row.categoryId}
              title={grownTitleOf(row, insight.baseCurrency)}
              isTitleWrapping
              chevron
              onClick={() => {
                onOpenCategory(row.categoryId);
              }}
            />
          ))}
        </List>
      )}
    </>
  );
};
